import { render } from "./CreateAkhir.vue?vue&type=template&id=50d4ea3d"
import script from "./CreateAkhir.vue?vue&type=script&lang=js"
export * from "./CreateAkhir.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__